import {
  Content as DropdownMenuContent,
  Group as _Group,
  Item as _Item,
  ItemIndicator as _ItemIndicator,
  Label as _Label,
  RadioGroup as _RadioGroup,
  RadioItem as _RadioItem,
  Separator as _Separator,
} from '@radix-ui/react-dropdown-menu'
import React from 'react'

import { CSS, styled } from 'design'

// Export unstyled items
export { Root, Trigger } from '@radix-ui/react-dropdown-menu'

const groupStyles: CSS = {
  boxSizing: 'border-box',
  padding: '0 $2',
  width: '100%',

  '> * + *': {
    marginTop: '$1',
  },
}

export const Group = styled(_Group, groupStyles)
export const RadioGroup = styled(_RadioGroup, groupStyles)

const itemStyles: CSS = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  boxSizing: 'border-box',
  width: '100%',
  height: '$space$6',
  borderRadius: '$1',
  cursor: 'pointer',
  padding: '0 $2',

  '&:hover': {
    backgroundColor: '$grey50',
  },
}

export const Item = styled(_Item, itemStyles)
export const RadioItem = styled(_RadioItem, itemStyles)

export const ItemIndicator = styled(_ItemIndicator, {
  display: 'flex',
  fill: '$grey700',
})

const StyledDropdownMenuContent = styled(DropdownMenuContent, {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  fontSize: '$2',
  color: '$grey700',
  backgroundColor: '$backgroundSecondary',
  border: '1px solid $grey200',
  boxShadow: '$2',
  borderRadius: '$2',
  padding: '$3 0',

  '> * + *': {
    marginTop: '$3',
  },
})

export const Content = ({
  className,
  children,
  css,
  ...props
}: React.ComponentProps<typeof StyledDropdownMenuContent>) => {
  return (
    <StyledDropdownMenuContent
      className={className}
      css={css as any}
      {...props}
    >
      {children}
    </StyledDropdownMenuContent>
  )
}

export const Label = styled(_Label, {
  padding: '0 $4',
  fontSize: '$3',
  color: '$grey500',
})

export const Separator = styled(_Separator, {
  width: '100%',
  height: '1px',
  backgroundColor: '$grey200',
})
